export default function FeatureSection() {
  const features = [
    {
      icon: 'ri-flashlight-line',
      title: '极速浏览体验',
      desc: '采用新一代渲染引擎，页面加载速度提升40%，即使在弱网环境下也能实现秒开网页。智能预加载技术让浏览更加流畅顺滑。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '全方位隐私保护',
      desc: '内置强大的广告拦截和追踪防护功能，自动阻止第三方追踪器。无痕浏览模式确保您的上网记录不被保存，指纹保护防止设备被唯一标识。',
    },
    {
      icon: 'ri-stack-line',
      title: '智能多标签管理',
      desc: '支持标签分组、快速切换、批量操作等高效管理功能。标签云视图让您一目了然所有打开的页面，长按即可进行批量管理。',
    },
    {
      icon: 'ri-moon-line',
      title: '护眼夜间模式',
      desc: '智能夜间模式有效减少蓝光辐射，保护视力。支持定时自动切换和跟随系统深色模式，让夜间浏览更加舒适健康。',
    },
    {
      icon: 'ri-translate',
      title: '智能网页翻译',
      desc: '内置先进的神经网络翻译引擎，支持50+种语言互译，翻译准确流畅。自动检测外文网页并一键翻译，打破语言障碍。',
    },
    {
      icon: 'ri-download-cloud-2-line',
      title: '强大下载管理',
      desc: '支持多线程下载、断点续传、视频嗅探下载等功能。智能下载管理器自动分类文件，下载速度提升60%，让资源获取更高效。',
    },
    {
      icon: 'ri-bookmark-line',
      title: '智能书签同步',
      desc: '跨设备云端同步书签、历史记录和密码。端到端加密传输确保数据安全，换设备也能无缝继续浏览。',
    },
    {
      icon: 'ri-speed-mini-line',
      title: '数据节省模式',
      desc: '智能压缩网页数据，最高节省60%流量。在移动网络下自动开启，帮助您节省流量费用，同时保持流畅的浏览体验。',
    },
  ];

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 rounded-full text-sm font-medium mb-4">
            核心功能
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            为什么选择91浏览器？
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            我们精心打造每一项功能，只为给你最好的移动浏览体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feat, idx) => (
            <div
              key={idx}
              className="group p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${feat.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}